import { render, staticRenderFns } from "./deleteCalcRule.vue?vue&type=template&id=6cd5bc57&scoped=true"
import script from "./deleteCalcRule.vue?vue&type=script&lang=js"
export * from "./deleteCalcRule.vue?vue&type=script&lang=js"
import style0 from "./deleteCalcRule.vue?vue&type=style&index=0&id=6cd5bc57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5bc57",
  null
  
)

export default component.exports